export const LegacyPowerUps = {
  calendar: '55a5d917446f517774210011',
  cardAging: '55a5d917446f517774210012',
  voting: '55a5d917446f517774210013',
  readMe: '5d6fd294c2588608fdbf2d33',
};
